<template>
  <div class="anchor" :style="{ top: toTopHeight + 'px' }">
    <div class="anchor-title">主播推荐</div>
    <div @click="enterRoom(item)" class="anchor-list" v-for="(item, index) in hotLives" :key="item.id">
      <div class="anchor-list-left">
        <div>
          <img class="anchor-list-avatar" :src="item.anchor_avatar ? item.anchor_avatar : defaultAvatar" alt="" />
          <div class="anchor-list-avatar-mask"></div>
        </div>
        <img @click.stop="subscription(item.anchorid, index)" class="anchor-list-subs" src="./share_guanzhu_on.png" v-if="item.isattent" alt="" />
        <img @click.stop="subscription(item.anchorid, index)" class="anchor-list-subs" src="./share_guanzhu_add.png" v-else alt="" />
      </div>
      <div class="anchor-list-right">
        <div class="anchor-list-up">
          <div class="anchor-list-up-left">
            <div class="anchor-name">{{ item.anchor_name }}</div>
            <div class="anchor-level-box">
              <img :src="require(`../../assets/img/anchor-levels/lv${item.level}.png`)" alt="" />
            </div>
            <div class="live-status-box">
              <img src="./live_status.png" alt="" />
            </div>
            <div v-show="item.Status" class="anchor-list-up-live">LIVE</div>
          </div>
          <div class="anchor-list-up-right">
            <img src="./live_heat.png" alt="" />
            <div>{{ bigNumber(item.hot) }}</div>
          </div>
        </div>
        <div class="anchor-list-down">
          {{ item.title }}
        </div>
      </div>
    </div>
    <div class="anchor-bottom">
      <div class="anchor-btn">换一批</div>
    </div>
  </div>
</template>

<script>
import { post } from "../../util/http";
import { mapState, mapMutations } from "vuex";
import { enterRoom } from "@/util/enterRoomTicket";

export default {
  props: ["toTopHeight", "position", "isLogin"],
  data() {
    return {
      defaultAvatar: require("./live_biaoqing.png"),
      // uid: this.userInfo.id ? this.userInfo.id : 0,
      hotLives: [],
    };
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  mounted() {
    console.log("hotLives::::", this.hotLives);
    this.getHotLives();
  },
  destroyed() {},
  methods: {
    ...mapMutations(["toggleLogin"]),
    enterRoom,

    bigNumber(num) {
      if (num >= 10000) {
        num = Math.round(num / 1000) / 10 + "W";
      }
      return num;
    },
    async getHotLives() {
      const {
        data: { data },
      } = await post({
        url: "/api/home/getHomeUserRecLive",
        data: {
          size: 6,
        },
      });
      let live = data;
      if (live?.length > 7) {
        live = live?.slice(0, 7);
      }
      this.hotLives = live;
    },

    async subscription(anchorid, index) {
      if (!this.userInfo.id) {
        this.toggleLogin();
        return;
      }
      const {
        data: { data },
      } = await post({
        url: "/api/anchor/attentAnchor",
        data: {
          anchorid: anchorid,
        },
      });
      if (data.type) {
        this.hotLives[index].isattent = 1;
        this.$message({
          message: "关注成功！",
          type: "success",
        });
      } else {
        this.hotLives[index].isattent = 0;
        this.$message({
          message: "取消关注！",
          type: "warning",
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.anchor {
  position: sticky;
  width: 3.75rem;
  max-height: 7.85rem;
  background-color: #fff;
  border-radius: 0.08rem;
  display: flex;
  flex-direction: column;
  box-shadow: 0rem 0.03rem 0.12rem 0rem rgba(0, 0, 0, 0.1);
  .anchor-title {
    height: 0.48rem;
    background: linear-gradient(to right, rgba(41, 241, 156, 0.2), rgba(2, 161, 249, 0.2));

    border-radius: 0.08rem 0.08rem 0 0;
    display: flex;
    align-items: center;
    padding-left: 0.16rem;
    font-size: 0.16rem;
    color: #333;
    font-weight: bold;
  }
  .anchor-list {
    height: 0.96rem;
    padding: 0.16rem 0;
    margin: 0 0.12rem;
    display: flex;
    flex-direction: row;
    border-bottom: 0.01rem solid #f0f0f0;
    cursor: pointer;
    .anchor-list-left {
      margin-right: 0.12rem;
      position: relative;
      .anchor-list-avatar {
        margin-top: 0.1rem;
        width: 0.72rem;
        height: 0.72rem;
        border-radius: 0.64rem;
      }
      .anchor-list-avatar-mask {
        position: absolute;
        top: 0.08rem;
        left: -0.02rem;
        height: 0.76rem;
        width: 0.76rem;
        border-radius: 50%;
        background-color: transparent;
        background-clip: padding-box, border-box;
        background-origin: padding-box, border-box;
        background: linear-gradient(to right, rgba(41, 241, 156, 1), rgba(2, 161, 249, 1));
        z-index: -2;
      }
      .anchor-list-subs {
        position: absolute;
        left: 0.22rem;
        bottom: -0.12rem;
        width: 0.28rem;
        height: 0.28rem;
        cursor: pointer;
      }
    }
    .anchor-list-right {
      flex: 1;
      width: 0;
      margin: 0.08rem 0;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .anchor-list-up {
        display: flex;
        justify-content: space-between;
        margin-top: 0.08rem;
        .anchor-list-up-left {
          display: flex;
          align-items: center;
          font-weight: 400;
          font-size: 0.18rem;
          color: #333;
          width: 100%;

          .anchor-name {
            max-width: 1.45rem;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .anchor-level-box {
            margin-left: 0.04rem;
            line-height: 0.16rem;
            width: 0.4rem;
            height: 0.16rem;
            img {
              height: 100%;
            }
          }
          .live-status-box {
            margin-left: 0.15rem;
            width: 0.24rem;
            height: 0.24rem;
            img {
              height: 100%;
            }
          }
        }
        .anchor-list-up-live {
          width: 0.3rem;
          height: 0.16rem;
          margin-left: 0.06rem;
          color: #26d99d;
          font-size: 0.1rem;
          background: rgba(38, 217, 157, 0.1);
          border: 0.01rem solid #26d99d;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .anchor-list-up-right {
          display: flex;
          align-items: center;
          font-size: 0.12rem;
          color: #999;
        }
        .anchor-list-up-right img {
          width: 0.12rem;
          height: 0.14rem;
          margin-right: 0.03rem;
        }
      }
      .anchor-list-down {
        display: inline;
        font-size: 0.16rem;
        color: #999;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  .anchor-bottom {
    height: 0.64rem;
    display: flex;
    justify-content: center;
    align-items: center;
    .anchor-btn {
      width: 1.28rem;
      height: 0.36rem;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(2, 168, 162, 0.2);
      border: 0.01rem solid rgba(13, 194, 134, 1);
      border-radius: 0.18rem;
      font-size: 0.16rem;
      color: #02a8a2;
    }
    .anchor-btn:hover {
      background: #02a8a2;
      color: #fff;
      cursor: pointer;
    }
  }
}
</style>
